import { BaseComponent } from 'project/general';

class FeaturedServicesComponent extends BaseComponent {

    static getNamespace() {
        return 'featured-services-slider';
    }

    onInit() {
        var owlServices = $(this.element);

        $(owlServices).owlCarouselProgressBar({
            size: '3px',
            borderRadius: 2.5,
            margin: '15px 0 0',
            foregroundColor: '#d0c0ef',
            color: '#4203bf',
            transitionInterval: 1,
            progressBarClassName: 'scrollbar',
            scrollerClassName: 'scrollbar__scroller'
        });

        owlServices.owlCarousel({
            margin: 30,
            nav: false,
            dots: false,
            autoHeight: true,
            smartSpeed: 1000,
            responsive: {
                0: {
                    items: 1,
                },
                768: {
                    items: 2,
                },
                964: {
                    items: 3,
                }
            },
            onInitialized: function (event) {
                $(owlServices).find('.owl-item').attr('aria-selected', 'false');
                $(owlServices).find('.owl-item.active').attr('aria-selected', 'true'); // let screen readers know an item is active

                // apply meta info to next and previous buttons and make them focusable
                $(owlServices).parent().find('.owl-buttons__button--owl-next').attr('role', 'button').attr('title', 'Previous');
                $(owlServices).parent().find('.owl-buttons__button--owl-next').attr('title', 'Next');
                $(owlServices).attr('tabindex', '0');
                $('.owl-buttons__button--owl-next, .owl-buttons__button--owl-prev').attr('tabindex', '0');

                // listen for keyboard input
                $(document).on('keydown', function (e) {

                    var $focusedElement = $(document.activeElement),
                        singleOwl = $(owlServices).data('owlCarousel'),
                        type = e.which == 39 ? 'next' : null,
                        type = e.which == 37 ? 'prev' : type,
                        type = e.which == 13 ? 'enter' : type;


                    // if the carousel is focused, use left and right arrow keys to navigate
                    if ($focusedElement.attr('id') === "featured-services-slider") {
                        if (type == 'next') {
                            owlServices.trigger('next.owl.carousel');
                        } else if (type == 'prev') {
                            owlServices.trigger('prev.owl.carousel');
                        }

                        // if the prev and next buttons are focused, catch "Enter" and navigate in the right direction
                    } else if (type == 'enter') {
                        if ($focusedElement.hasClass('owl-buttons__button--owl-next')) {
                            owlServices.trigger('next.owl.carousel');
                        } else if ($focusedElement.hasClass('owl-buttons__button--owl-prev')) {
                            owlServices.trigger('prev.owl.carousel');
                        }
                    }
                });
            }
        });

        // Button actions for next & Prev
        $('#featured-services-next').click(function () {
            owlServices.trigger('next.owl.carousel');
        });

        $('#featured-services-prev').click(function () {
            owlServices.trigger('prev.owl.carousel');
        });
    }

}

export default FeaturedServicesComponent;
